export default {
  NONE: 0,
  SHOP: 1,
  GROUP: 2,
}



// WEBPACK FOOTER //
// ./js/ShopType.js